export default __webpack_public_path__ + "static/media/settings.d9859822.svg";